import { InjectionToken } from '@angular/core'

export const shoppingCartApp = {
  BeatmakerTv: 0,
  BeatmakersTv: 1,
  Producer: 2,
  Widget: 3
} as const

export type ShoppingCartApp = (typeof shoppingCartApp)[keyof typeof shoppingCartApp]

export const SHOPPING_CART_APP_TYPE = new InjectionToken<ShoppingCartApp>('AppType')
